import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { OpenDialogCreateAddress } from '../../../../store/actions';
import '../address.css';

export default function NotHaveShippingAddress() {
    const dispatch = useDispatch();
    const wording = useSelector(({ language }) => language.wording);

    return (
        <div className='row items-grid'>
            <div
                className='col-md-12 col-xs-12 product product-grid pt-10 pb-10 ml-10 mr-10'
                style={{
                    backgroundColor: '#1B1B1B',
                    color: '#000',
                    marginTop: 5,
                    marginBottom: 5,
                    borderRadius: 4
                }}>
                <div className='row'>
                    <div className='address-header col-md-12 pt-10 pb-20 pr-20 line'>
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'flex-end'
                            }}>
                            <button
                                className='btn btn-md btn-light'
                                onClick={() => dispatch(OpenDialogCreateAddress())}>
                                {wording.usermenu.address.shippingAddress.add}
                            </button>
                        </div>
                    </div>
                    <div className='address-body col-md-12 mt-20 mb-60'>
                        <div className='text-center'>
                            <div className='icon-warpper'>
                                <img src='/assets/img/sf/shipping-address.png' alt='shipping-address.png' />
                            </div>
                            <h1 className='uppercase'>
                                {wording.usermenu.address.shippingAddress.notHaveShippingAddress}
                            </h1>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
